import { AuctionInfo } from '../stores/auctionStore';

export default (auctionInfo: AuctionInfo) => {
  if (auctionInfo.in_play_tokens.length === 0) return 0;
  const ticketWorth = BigInt(auctionInfo.auction_state.mint_pot) / BigInt(auctionInfo.in_play_tokens.length) / BigInt(1000000);
  const nft_price = BigInt(auctionInfo.configs.nft_price) / BigInt(1000000);
  return Math.round((Number(ticketWorth) / Number(nft_price)) * 1000000) / 1000000;
};
